import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Clock, Calendar } from 'lucide-react';
import { getAuthorById } from '../../../../../data/authors';
import { getCategoryBySlug } from '../../../../../data/categories';
import './BlogCard.css';

const BlogCard = ({ post, index }) => {
  const author = getAuthorById(post.authorId);
  const categorySlug = post.category.toLowerCase().replace(/\s+/g, '-');
  const category = getCategoryBySlug(categorySlug);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  return (
    <motion.article
      className="blog-card"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{ y: -8 }}
    >
      <Link to={`/blog/${post.slug}`} className="blog-card-link">
        <div className="blog-card-image-wrapper">
          <img 
            src={post.featuredImage} 
            alt={post.title}
            className="blog-card-image"
            loading="lazy"
          />
          <span 
            className="blog-card-category"
            style={{ backgroundColor: category?.color || '#6B7280' }}
          >
            {post.category}
          </span>
        </div>

        <div className="blog-card-content">
          <h3 className="blog-card-title">{post.title}</h3>
          <p className="blog-card-excerpt">{post.excerpt}</p>

          <div className="blog-card-meta">
            <div className="blog-card-author">
              {author && (
                <>
                  <img 
                    src={author.photo} 
                    alt={author.name}
                    className="blog-card-author-photo"
                  />
                  <span className="blog-card-author-name">{author.name}</span>
                </>
              )}
            </div>

            <div className="blog-card-info">
              <span className="blog-card-date">
                <Calendar size={14} />
                {formatDate(post.publishDate)}
              </span>
              <span className="blog-card-read-time">
                <Clock size={14} />
                {post.readTime} min read
              </span>
            </div>
          </div>

          <div className="blog-card-footer">
            <span className="blog-card-read-more">
              Read More →
            </span>
          </div>
        </div>
      </Link>
    </motion.article>
  );
};

export default BlogCard;